import {$} from "../Dom.ts";


document.addEventListener('DOMContentLoaded', () => {
    $('#efface-historique-btn')?.addEventListener('click', effaceHistorique)
    if (!window.Openscop.is_log && !window.location.pathname.includes("/accounts/")) {
        // window.history.replaceState(null, "", "/"); // Evite de garder l'url dans l'historique si pas loggué
       }

});

function effaceHistorique(event: DOMEvent<HTMLInputElement>) {
    event.preventDefault()
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach(function(c) {
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
    if ('caches' in window) {
            caches.keys().then(function(names) {
                names.forEach(function(name) {
                    caches.delete(name);
                });
            });
        }
    window.location.replace('https://www.google.com');
}